import React, {useEffect, useRef, useState} from "react";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./tournamentDetails.css";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import arrowDown from "../../assets/images/arrowDown.png";
import arrowUp from "../../assets/images/arrowUp.png";
import moment from "moment";
import axios from "axios";
import {BASE_URL} from "../../constant/apiURL";
import ApiEndpoints from "../../utils/ApiEndpoints";
import LoadingButton from "@mui/lab/LoadingButton";
import MainModal from "../../components/MainModal";

import {makeStyles} from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import MainMenu from "../../components/MainMenu";
import Divider from "@mui/material/Divider";
import {useDispatch, useSelector} from "react-redux";
import uniqid from "uniqid";
import {clearPOTYTournament, getPOTYTournamentById, updatePlayerStatus,} from "../../redux/actions/tournament-action";
import AddIcon from "@mui/icons-material/Add";
import {createDraw, sendDraws} from "../../redux/actions/draw-action";
import {useNavigate, useParams} from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import RemoveCircleRoundedIcon from "@mui/icons-material/RemoveCircleRounded";
import {styled} from "@mui/material/styles";
import {convertTime12To24, removeElementFromArray,} from "../../helpers/Common";
import clsx from "clsx";
import {apiGet} from "../../utils/apiRequests";
import POTYTournamentDetails from "../POTYTournamentDetails";
import {toast} from "react-toastify";
import {automaticDraws} from "../../utils/automaticDraws";

const useStyles = makeStyles(() => ({
  outlineInputBorder: {
    "& * > fieldset > legend": {
      display: "none",
    },
    "& > fieldset > legend > span": {
      display: "none",
    },
  },
  outlinedInputBox: {
    "& input[type='time' i]::-webkit-datetime-edit": {
      display: "none",
    },
    "& * > fieldset": {
      border: "none",
    },
    padding: 0,
  },
  stack1: {
    backgroundColor: "#C4C4C4",
    borderRadius: "5px",
  },
  stack2: {
    backgroundColor: "#2C633C",
    borderRadius: "5px",
  },
  tournamnetBox: {
    // padding:""
    // width: "138px",
    // textAlign: "center",
  },
  divider: {
    border: "1px solid black !important",
    height: "5px !important",
  },
  dividerBox: {
    backgroundColor: "black !important",
  },
  groupingBox: {
    backgroundColor: "#06623B",
  },
  createDrawsBtnContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  createDrawsBtnIcon: {
    backgroundColor: "#06623B",
  },
  createDrawsText: {
    fontWeight: "bolder  !important",
    marginLeft: "5px  !important",
    fontSize: "0.8em !important",
  },
  addGroupCard: {
    border: "2px dashed grey",
    display: "flex",
  },
  playerListHeading: {
    fontWeight: "700 !important",
  },
  confirmDrawBtn: {
    width: "10.5em !important",
    textTransform: "capitalize !important",
    backgroundColor: "#06623B !important",
    color: "#FFF !important",
  },
  teeColorBox: {
    fontWeight: "700 !important",
  },
  playerListText: {
    fontSize: "0.9em !important",
  },
  timeTextField: {
    borderRadius: "5px",
    padding: "0px !important",
    "& input[type='time' i]::-webkit-calendar-picker-indicator": {
      padding: "0px !important",
      margin: "0px !important",
      filter: "invert(1) !important",
    },
    "& input[type='date' i]::-webkit-calendar-picker-indicator": {
      padding: "0px !important",
      margin: "0px !important",
      filter: "invert(1) !important",
    },
    "& input[type='date' i]::-webkit-datetime-edit": {
      display: "none",
    },
  },
  clockInputAdornment: {
    backgroundColor: "#2C633C !important",
    color: "white",
    marginLeft: "4px !important",
    height: "65px !important",
    borderRadius: "5px",
    padding: "0px !important",
  },
  timeInput: {
    "& > div:first-child": {
      //   padding: 0,
    },
    "& > div > div:first-child": {},
    padding: "0 !important",
    // height: "35px",
  },
  scrollBarStyle: {
    "&::-webkit-scrollbar": {
      width: "5px !important",
    },
    // Track
    "&::-webkit-scrollbar-track": {
      background: "#C4C4C4 !important",
    },
    // Handle
    "&::-webkit-scrollbar-thumb": {
      background: "#06623B !important",
    },
    // Handle on Hover
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#06623B !important",
    },
  },
  group_droppableArea: {
    border: "0px dashed #007e0038",
    height: "200px",
  },
  group_droppableAreaActive: {
    borderWidth: "2px",
  },
  listDroppableArea: {
    border: "0px dashed #007e0038",
    minHeight: "50px",
    height: "fit-content",
    // height: "320px"
  },
  listDroppableAreaActive: {
    borderWidth: "2px",
  },
  SaveBtn: {
    "&>div": {
      color: "WHITE",
      whiteSpace: "nowrap",
    },
  },
  SendDrawsBtn: {
    "&:hover": {
      background: "#C60808 !important",
      border: "0px !important",
      color: "White",
      "&>span": {
        //for ripple
        background: "#C60808",
        display: "none",
      },
    },
    "&>div": {
      whiteSpace: "nowrap",
    },
  },
  leaderboardBtn: {
    borderRadius: "5px !important",
    "&:hover": {
      backgroundColor: "#06623B !important",
    },
  },
  groupTypo: {
    fontSize: "15px !important",
    fontWeight: "600 !important",
    width: "40px",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRight: "1px solid #ccc",
  },
  groupSelect: {
    "& *": {
      borderRadius: "0px !important",
      border: "0px !important",
    },
    "& > svg": {
      height: "100% !important",
      right: "0px !important",
      backgroundColor: "white",
      top: "0px",
    },
  },
}));

const token = localStorage.getItem("token");

function TournamentDetails(props) {
  const classes = useStyles();
  const { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const TournamentID = window.location.pathname.split("/")[2];
  const [toggleDraws, setToggleDraws] = useState(false);
  const [showCreateDraws, setShowCreateDraws] = useState(false);
  const [showRedoDraws, setShowRedoDraws] = useState(false);
  const [showGroups, setShowGroups] = useState(false);
  const [teeAndHandicap, setTeeAndHandicap] = useState();
  const [drawVal, setDrawVal] = useState("");
  const [teeOffsFrom, setTeeOffsFrom] = useState("Both Sides");
  const [groupDragStarted, setgroupDragStarted] = useState(false);
  const [courseColor, setCourseColor] = useState();
  const [teeColor, setTeeColor] = useState("Blue");
  const [createDrawsData, setCreateDrawsData] = useState({
    teeOff_time: "",
    timeBetweenFlights: "",
    drawMethod: "",
    teeOffsFrom: "",
    teeOff_timeObj: "",
  });
  const [playerList, setPlayerList] = useState({
    confirmed: [],
    pending: [],
    refused: [],
  });

  const [openedList, setOpenList] = useState({
    confirmed: false,
    pending: false,
    refused: false,
  });

  const [groups, setGroups] = useState([]);
  const [formSaving, setFormSaving] = useState(false);
  const [formSavedTextShow, setFormSavedTextShow] = useState(false);
  const [sendingDraws, setSendingDraws] = useState(false);
  const [drawsSentTextShow, setDrawsSentTextShow] = useState(false);
  const [sendDrawsError, setSendDrawsError] = useState("");
  const [refresh, setRefresh] = useState(false);

  //#region redux selector
  const tournamentName = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.tournament_name
  );
  const courseName = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.course_name
  );
  const sponsorName = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.sponsor_name
  );
  const sponsorCompany = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.sponsor_company
  );

  const teeOff_time = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.tee_off
  );
  const timeBetween_Flights = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.timeBetweenFlights
  );
  const teeOffsFromValue = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.teeOffsFrom
  );
  const drawMethodValue = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.drawMethod
  );
  const players = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.players
  );

  const [count, setCount] = useState();
  const [drawCreationModes, setdrawCreationModes] = useState([]);
  const [teeOffsFromSelectData, setteeOffsFromSelectData] = useState([]);

  const courseID = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.course_id
  );

  const [teeOffTime, setTeeOffTime] = useState(null);

  const tournamentData = useSelector(
    (state) => state?.getOneTournamentReducer?.data
  );
  const { role } = useSelector((state) => state.userDetailsReducer);

  const [selectDisable, setSelectDisable] = useState(false);

  const [showLeaderboard, setShowLeaderboard] = useState(false);

  const [showGroupingBtn, setShowGroupingBtn] = useState(false);

  const [groupBtnDraw, setGroupBtnDraw] = useState(false);

  const [drawTeeTime, setDrawTeeTime] = useState("");

  const timeInputIconRef = useRef(null);

  const [emailConfModalOpen, setEmailConfModalOpen] = useState(false);

  const _handleOnClickLeaderboard = () => {
    setShowLeaderboard(true);
    setShowGroupingBtn(true);
  };

  const _handleOnClickGrouping = () => {
    setShowLeaderboard(false);
    setShowGroupingBtn(false);
    setRefresh(!refresh);
  };

  const _handleOnClickGroupingInDraws = () => {
    setShowGroupingBtn(false);
    setShowLeaderboard(false);
    setGroupBtnDraw(false);

    setToggleDraws(false);

    // for create draws button toggle
    setShowRedoDraws(true);
    if (showRedoDraws == true) {
      setShowCreateDraws(false);
    } else {
      setShowCreateDraws(true);
    }
  };

  const _handleChangeDrawMethod = (e) => {
    const { value } = e.target;
    setDrawVal(value);
  };

  const _handleChangeTeeOff = (e) => {
    const { value } = e.target;
    setTeeOffsFrom(value);
  };

  const _handleChangeCourse = (e, index) => {
    const { value } = e.target;

    let tempArr = [...groups];

    tempArr[index].course_name = value;

    setGroups(tempArr);
  };

  const _handleChangeTeeColor = (e, groupName, user_id) => {
    const { value } = e.target;
    let l_groups = [...groups];

    let groupIndex = l_groups.findIndex((val) => val.group_name === groupName);

    let playerIndex = l_groups[groupIndex].draw_players.findIndex(
      (player) => player.user_id === user_id
    );

    // if (l_groups[groupIndex].draw_players[playerIndex].mp_score.length > 0) {
    //   return toast.error("Can't change tee. Player's score already entered");
    // }

    apiGet(`/api/user/basic-info/${user_id}`, (res) => {
      let filterTee = res.data.user_tee.filter(
        (val) => val.tee_color === value
      );

      var group_index = l_groups.findIndex(
        (gr) => gr?.group_name === groupName
      );

      let l_group_players = [...l_groups[group_index].draw_players];

      var selected_playerIndex = l_group_players.findIndex(
        (draw_player) => draw_player?.user_id === user_id
      );

      l_group_players[selected_playerIndex].tee = value;

      l_groups[group_index].draw_players[selected_playerIndex].tee = value;
      l_groups[group_index].draw_players[
        selected_playerIndex
      ].playing_handicap = filterTee[0].handicap_value;

      setGroups(l_groups);
    });
  };

  const onIncrement = () => {
    // Update state with incremented value
    const countValue = parseInt(count);
    setCount(countValue + 1);
  };

  const onDecrement = () => {
    const countValue = parseInt(count);
    countValue !== 0 && setCount(countValue - 1);
  };

  const handleDraws = () => {
    const data = {
      tee_off: drawTeeTime,
      teeOff_time: teeOffTime.toISOString(true),
      timeBetweenFlights: count,
      drawMethod: drawVal,
      teeOffsFrom: teeOffsFrom,
    };
    if (data.tee_off == "") {
      return toast.error("Enter Tee Off Time");
    } else if (data.timeBetweenFlights === 0) {
      return toast.error("Enter time between flights");
    } else if (data.teeOffsFrom === undefined) {
      return toast.error("Select Tee Off From");
    } else if (data.drawMethod === undefined) {
      return toast.error("Select Draw Method");
    } else {
      dispatch(createDraw(data, TournamentID));
      setCreateDrawsData(data);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  };

  const _handleOnChangeTeeOff = (e) => {
    const { value } = e.target;
    let l_value = value;
    const hour = l_value.split(":")[0];
    const minute = l_value.split(":")[1];
    let xyz = moment(l_value);
    const l_groups = [...groups];

    var ts = value;
    var H = +ts.substr(0, 2);
    var h = H % 12 || 12;
    h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " AM" : " PM";
    ts = h + ts.substr(2, 3) + ampm;
    setDrawTeeTime(ts);
  };

  const _handleCreateDrawsOnClick = () => {
    setToggleDraws(true);
    setShowCreateDraws(true);
    setShowRedoDraws(false);
    populateDrawsSelects();
    setShowGroupingBtn(true);
  };

  const _handleRedoDrawsOnClick = () => {
    setToggleDraws(true);
    setShowCreateDraws(true);
    setShowGroups(false);
    setShowRedoDraws(false);
    populateDrawsSelects();
    // setShowGroupingBtn(true);
    setGroupBtnDraw(true);
    //showRedoDraws
  };

  const populateDrawsSelects = () => {
    setdrawCreationModes(["Manual", "Automatic"]);
    getFrontAndBackCourses();
  };

  const _handleAddGroup = (e, index) => {
    setToggleDraws(false);
    setShowCreateDraws(true);
    setShowGroups(true);
    let l_groups = [...groups];

    var courseName =
      createDrawsData.teeOffsFrom.toLowerCase() === "both sides"
        ? l_groups.length % 2
          ? teeAndHandicap?.back_9
          : teeAndHandicap?.front_9
        : createDrawsData.teeOffsFrom;

    let tee_off_time = createDrawsData.teeOff_timeObj;

    const timeBetweenFlights_val = createDrawsData?.timeBetweenFlights;

    if (createDrawsData.teeOffsFrom.toLowerCase() === "both sides") {
      let teeTime = tee_off_time; // 8:55

      if (l_groups.length >= 2) {
        for (let i = 2; i <= l_groups.length; i += 2) {
          teeTime = moment(teeTime).add(timeBetweenFlights_val, "minute");
        }

        l_groups.push({
          draw_index: l_groups.length,
          dateTime: teeTime.toISOString(true),
          group_name: "group " + parseInt(l_groups.length + 1),
          course_name: courseName,
          draw_players: [],
          time: teeTime.format("LT"),
          timeObj: teeTime,
        });
      } else {
        l_groups.push({
          draw_index: l_groups.length,
          dateTime: teeTime,
          group_name: "group " + parseInt(l_groups.length + 1),
          course_name: courseName,
          draw_players: [],
          time: moment(teeTime).format("LT"),
          timeObj: teeTime,
        });
      }
    } else {
      let teeTime = tee_off_time;
      for (let i = 1; i <= l_groups.length; i++) {
        teeTime = moment(teeTime).add(timeBetweenFlights_val, "minute");
      }

      l_groups.push({
        id: l_groups.length + 1,
        draw_index: l_groups.length,
        dateTime: teeTime.toISOString(true),
        group_name: "group " + parseInt(l_groups.length + 1),
        course_name: courseName,
        draw_players: [],
        time: moment(teeTime).format("LT"),
        timeObj: teeTime,
      });
    }
    setGroups(l_groups);
  };

  const getUserTeeHandicaps = async (userId, courseId) => {
    const res = await axios.post(
      `${BASE_URL}${ApiEndpoints.user.base}${ApiEndpoints.user.playerHandicap}`,
      {
        user_id: userId,
        course_id: courseId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res?.data?.dataArray;
  };

  const _handleDragStart = () => {
    setgroupDragStarted(true);
  };

  const handleListItemOnDragEnd = (result) => {
    setgroupDragStarted(false);

    const items = Array.from(groups);

    if (
      result.destination.droppableId.includes("group") &&
      result.source.droppableId.indexOf("group") !== -1
    ) {
      let sourceIndex = items.findIndex(
        (element) => element.group_name === result.source.droppableId
      );

      let destinationIndex = items.findIndex(
        (element) => element.group_name === result.destination.droppableId
      );

      let filterGroup = items.filter(
        (val) => val.group_name === result.source.droppableId
      );

      if (result.source.droppableId !== result.destination.droppableId) {
        if (
          filterGroup[0].draw_players[result.source.index].mp_score.length > 0
        ) {
          return toast.error(
            "Can't update draw. Player's score has been entered",
            {
              toast: filterGroup[0].draw_players[result.source.index].user_id,
            }
          );
        }
      }

      if (items[destinationIndex].draw_players.length <= 3) {
        let [transferVal] = items[sourceIndex].draw_players.splice(
          result.source.index,
          1
        );

        items[destinationIndex].draw_players.splice(
          result.destination.index,
          0,
          transferVal
        );
      }
    }

    if (
      result.destination.droppableId.includes("group") &&
      result.source.droppableId.indexOf("group") === -1
    ) {
      var groupName = result.destination.droppableId;
      var selectedGroupIndex = groups.findIndex(
        (group) => group.group_name === groupName
      );
      var sourceListName = result.source.droppableId;
      var sourceListItemIndex = result.source.index;
      var selectedPlayer = playerList[sourceListName][sourceListItemIndex];

      var l_groups = [...groups];

      if (l_groups[selectedGroupIndex].draw_players.length <= 3) {
        l_groups[selectedGroupIndex].draw_players.push(selectedPlayer);
        setGroups(l_groups);

        var SourceItems = Array.from(playerList[sourceListName]);
        SourceItems.splice(sourceListItemIndex, 1);
        setPlayerList({
          ...playerList,
          [sourceListName]: SourceItems,
        });
      }

      if (result.source.droppableId != "confirmed") {
        const data = {
          player_id: selectedPlayer._id,
          status: "confirmed",
        };
        const tournamentID = id;
        dispatch(updatePlayerStatus(data, tournamentID));
        var SourceItems = Array.from(playerList[sourceListName]);
        SourceItems.splice(sourceListItemIndex, 1);
        setPlayerList({
          ...playerList,
          [sourceListName]: SourceItems,
        });
      }
    } else if (
      result.source.droppableId.includes("group") &&
      result.destination.droppableId.indexOf("group") !== -1
    ) {
      // using just so it doesnt give error
    } else if (
      result.source.droppableId.includes("group") &&
      result.destination.droppableId.indexOf("group") === -1
    ) {
      // dropping from group back to list
      //#region set group changes

      var l_groups = [...groups];
      var selectedGroupIndex = groups.findIndex(
        (group) => group.group_name === result.source.droppableId
      );
      var l_group_players = Array.from(
        l_groups[selectedGroupIndex].draw_players
      );
      var selectedItemIndexOnPlayers = result.source.index;
      var seletedItem = l_group_players[selectedItemIndexOnPlayers];
      l_group_players.splice(selectedItemIndexOnPlayers, 1);
      l_groups[selectedGroupIndex].draw_players = l_group_players;
      setGroups(l_groups);
      //#endregion
      //#region update destination
      const DestinationListKey = result.destination.droppableId;
      var DestinationItems = Array.from(playerList[DestinationListKey]);
      DestinationItems.push(seletedItem);

      const data = {
        player_id: seletedItem._id,
        status: DestinationListKey,
      };
      const tournamentID = id;
      dispatch(updatePlayerStatus(data, tournamentID));

      setPlayerList({
        ...playerList,
        [DestinationListKey]: DestinationItems,
      });
      if (!openedList[DestinationListKey]) {
        // if destination list is collapsed this will open it
        setOpenList({
          ...openedList,
          [DestinationListKey]: true,
        });
      }
      if (DestinationItems.length === 0) {
        //destination list is empty
      } else {
        //destination list is not empty
      }
      //#endregion
    } else {
      //list functions
      if (result.destination.droppableId === result.source.droppableId) {
        // same list drop
        const playerListKey = result.destination.droppableId;
        const items = Array.from(playerList[playerListKey]);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        setPlayerList({
          ...playerList,
          [playerListKey]: items,
        });
      } else {
        //dropping to another list

        // if (
        //   (result.destination.droppableId === "confirmed" &&
        //     result.source.droppableId === "pending") ||
        //   (result.destination.droppableId === "confirmed" &&
        //     result.source.droppableId === "refused")
        // ) {
        // if ()
        let sourceKey = result.source.droppableId;
        let destinationKey = result.destination.droppableId;

        let sourcePlayers = playerList[sourceKey].filter(
          (val, index) => index !== result.source.index
        );

        let data = {
          player_id: playerList[sourceKey][result.source.index],
          status: destinationKey,
        };

        dispatch(updatePlayerStatus(data, id));

        setPlayerList((pre) => {
          return {
            ...pre,
            [sourceKey]: sourcePlayers,
            [destinationKey]: [
              ...pre[destinationKey],
              playerList[sourceKey][result.source.index],
            ],
          };
        });
        // }
        // else {
        // const SourceListKey = result.source.droppableId;
        // const DestinationListKey = result.destination.droppableId;

        // var SourceItems = Array.from(playerList[SourceListKey]);
        // var DestinationItems = Array.from(playerList[DestinationListKey]);

        // const [reorderedItem] = SourceItems.splice(result.source.index, 1);
        // var itemIndex = playerList[SourceListKey].indexOf(reorderedItem);

        // const player_id = reorderedItem?._id;

        // const data = {
        //   player_id: player_id,
        //   status: DestinationListKey,
        // };

        // // const tournamentID = id;

        // dispatch(updatePlayerStatus(data, id));

        // SourceItems.splice(itemIndex, 1);

        // if (playerList[DestinationListKey].indexOf(reorderedItem) === -1) {
        //   // if array doesnt have this value only add it then
        //   if (playerList[DestinationListKey].length === 0) {
        //     //this element will be the first
        //     setPlayerList({
        //       ...playerList,
        //       [DestinationListKey]: [reorderedItem],
        //       [SourceListKey]: SourceItems,
        //     });
        //   } else {
        //     //state array has atleast 1 item
        //     var list = playerList[DestinationListKey];
        //     list.push(reorderedItem);
        //     setPlayerList({
        //       ...playerList,
        //       [DestinationListKey]: list,
        //       [SourceListKey]: SourceItems,
        //     });
        //   }
        // }
        // }
      }
    }
  };

  const handleListCollapseClick = (key) => {
    setOpenList({
      ...openedList,
      [key]: !openedList[key],
    });
  };

  const _handleOnSave = () => {
    const hasAnyEmptyGroup = groups.filter(
      (group) => group.draw_players.length == 0
    );

    if (hasAnyEmptyGroup.length > 0) {
      toast.error("Cannot save empty groups");
    } else {
      const data = {
        tee_off: tournamentData.tee_off,
        timeBetweenFlights: tournamentData?.timeBetweenFlights,
        teeOffsFrom: tournamentData?.teeOffsFrom,
        drawMethod: tournamentData?.drawMethod,
        draws: groups,
      };

      setFormSaving(true);

      dispatch(
        createDraw(data, TournamentID, (success) => {
          setFormSaving(false);
          setFormSavedTextShow(true);
          setTimeout(() => {
            setFormSavedTextShow(false);
          }, 1000);
        })
      );
    }
  };

  const _handleRemoveGroupOnClick = (groupIndex) => {
    let l_groups = [...groups];
    if (l_groups.length > 0) {
      l_groups[groupIndex].draw_players.forEach((player) => {
        let tournament_status = player.tournament_status;
        var DestinationItems = playerList[tournament_status];
        DestinationItems.push(player);
        setTimeout(() => {
          setPlayerList({
            ...playerList,
            [tournament_status]: DestinationItems,
          });
        }, 500);
      });
      l_groups.splice(groupIndex, 1);
      setGroups(l_groups);
    }
  };

  const _handleSendDraws = () => {
    setEmailConfModalOpen(true);
  };

  const getTeeAndHandicapValues = async (courseID) => {
    const res = await axios.get(
      `${BASE_URL}${ApiEndpoints.course.base}${ApiEndpoints.course.getFrontBackCourses}${courseID}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setTeeAndHandicap(res?.data);
  };

  const filterPlayerName = (userID) => {
    const result = players?.find((el) => el.user_id == userID);
    return result?.name;
  };

  const addExistingDraws = (tournamentDraws) => {
    let l_groups = [];
    tournamentDraws.forEach((draw) => {
      draw.draw_players.forEach((player) => {
        // const user_id = player.user_id;
        const tournament_status = player.tournament_status;

        var l_playerList = playerList;
        if (l_playerList[tournament_status]?.length > 0) {
          var playerIndex = l_playerList[tournament_status].findIndex(
            (user) => user.user_id == player.user_id
          );

          if (playerIndex !== -1) {
            l_playerList[tournament_status].splice(playerIndex, 1);
            setPlayerList(l_playerList);
          }
        }
      });

      var timeObj = moment(draw.dateTime);
      var groupIndex = parseInt(draw.group_name.split(" ")[1]);

      l_groups[groupIndex] = {
        ...draw,
        draw_index: groupIndex - 1,
        dateTime: timeObj,
        group_name: draw.group_name,
        course_name: draw.course_name,
        draw_players: draw.draw_players,
        time: timeObj.format("LT"),
        timeObj,
      };
    });

    l_groups = l_groups.filter(function (e) {
      return e != null;
    });

    setGroups(l_groups);
    // removePlayersFromPlayersList();
  };

  const getFrontAndBackCourses = () => {
    if (courseID)
      apiGet(
        `${ApiEndpoints.course.base}${ApiEndpoints.course.getFrontBackCourses}${courseID}`,
        (response) => {
          if (response.error === true) {
          } else {
            var front_9 = response.front_9,
              back_9 = response.back_9;

            setteeOffsFromSelectData(["Both Sides", front_9, back_9]);
          }
        },

        (error) => {}
      );
  };

  const removePlayersFromPlayersList = () => {
    let l_groups = groups,
      l_playerList = playerList;

    for (var l_group of l_groups) {
      if (l_group) {
        if (l_group?.draw_players.length > 0) {
          for (var draw_player of l_group?.draw_players) {
            for (var status of Object.keys(l_playerList))
              removeElementFromArray(
                l_playerList[status],
                "user_id",
                draw_player.user_id
              );
          }
        }
      }
    }
  };

  //#endregion

  //#region Components
  const HeaderItem = styled(Paper)(({ theme, noBG, head, rightBorder }) => ({
    backgroundColor: noBG ? "" : "#F2F2F2",
    // ...theme.typography.body1,
    padding: theme.spacing(0.55),
    textAlign: "center",
    color: theme.palette.text.secondary,
    borderRight: rightBorder ? " 1px solid grey" : "",
    border: head ? "0.5px solid #C4C4C4" : "none",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }));

  const GroupingButton = styled(Button)(({ theme }) => ({
    textTransform: "capitalize",
    color: "white !important",
    fontWeight: "bolder",
    backgroundColor: "#06623B",
  }));

  const HeaderItemComponent = (props) => {
    return (
      <HeaderItem elevation={0} square {...props}>
        <Typography
          textAlign="center"
          sx={{
            fontWeight: props.child ? "700" : "900",
            fontSize: "0.8em",
          }}
        >
          {props.text}
        </Typography>
      </HeaderItem>
    );
  };

  //#endregion

  //#region UseEffects

  useEffect(() => {
    if (role === "player") {
      return navigate("/poty-tournaments");
    }
  }, []);

  useEffect(() => {
    dispatch(getPOTYTournamentById(id));

    return () => {
      dispatch(clearPOTYTournament());
      setPlayerList((pre) => {
        return {
          pending: [],
          confirmed: [],
          refused: [],
        };
      });
    };
  }, [refresh]);

  useEffect(() => {
    let tempArr = [];

    tempArr = playerList;

    tournamentData?.players.map((player) => {
      const key = player.tournament_status;

      tempArr[key].push(player);
    });

    setPlayerList(tempArr);
  }, [tournamentData]);

  useEffect(async () => {
    if (tournamentData !== undefined) {
      if (
        tournamentData?.hasOwnProperty(
          "drawMethod",
          "teeOffsFrom",
          "timeBetweenFlights",
          "tee_off"
        )
      ) {
        //  'tee_off'
        setShowCreateDraws(true);
        setShowRedoDraws(true);

        const time = tournamentData?.tee_off
          ? convertTime12To24(tournamentData?.tee_off)
          : "11:14 AM";
        const hour = time.split(":")[0];
        const minute = time.split(":")[1];
        var l_teeOffTime = moment(tournamentData?.tournament_date)
          .set("hour", hour)
          .set("minute", minute);
        // console.error("tournamentData l_teeOffTime", l_teeOffTime.format("LT"))
        setCreateDrawsData({
          teeOff_time: l_teeOffTime.format("LT"),
          timeBetweenFlights: tournamentData?.timeBetweenFlights,
          drawMethod: tournamentData?.drawMethod,
          teeOffsFrom: tournamentData?.teeOffsFrom,
          teeOff_timeObj: l_teeOffTime,
        });

        setTeeOffTime(l_teeOffTime);
      } else {
        var l_teeOffTime = moment(tournamentData?.tournament_date);
        setCreateDrawsData({
          teeOff_time: l_teeOffTime.format("LT"),
          timeBetweenFlights: null,
          drawMethod: null,
          teeOffsFrom: null,
          teeOff_timeObj: l_teeOffTime,
        });

        setTeeOffTime(l_teeOffTime);
      }

      if (tournamentData.draws.length > 0) {
        addExistingDraws(tournamentData.draws);
        setDrawTeeTime(tournamentData.tee_off);
      } else {
        // Automatic Draws Algorithm
        if (
          tournamentData != null &&
          tournamentData?.drawMethod === "Automatic" &&
          teeAndHandicap !== undefined &&
          tournamentData.draws.length === 0
        ) {
          let autoAutoDraw = await automaticDraws(
            tournamentData,
            teeAndHandicap,
            teeOffTime
          );
          setPlayerList((pre) => {
            return {
              ...pre,
              confirmed: [],
            };
          });
          setGroups(autoAutoDraw.draws);
        }
      }
    }
  }, [tournamentData, teeAndHandicap]);

  useEffect(() => {
    if (courseID) getTeeAndHandicapValues(courseID);
  }, [courseID]);

  useEffect(() => {
    if (timeBetween_Flights) setCount(timeBetween_Flights);
  }, [timeBetween_Flights]);

  useEffect(() => {
    if (teeAndHandicap && teeOffsFromValue) {
      var teeOffValue = Object.values(teeAndHandicap).filter(
        (e) => typeof e === "string" && e === teeOffsFromValue
      );
      if (teeOffValue.length > 0) teeOffValue = teeOffValue.reduce((e) => e);
      setCourseColor(teeOffValue);
      setSelectDisable(true);
    }
    if (teeOffsFromValue !== undefined) {
      setTeeOffsFrom(teeOffsFromValue);
    }
  }, [teeOffsFromValue, teeAndHandicap, selectDisable]);

  useEffect(() => {
    setDrawVal(drawMethodValue);
  }, [drawMethodValue]);

  useEffect(() => {
    if (toggleDraws) {
      setCount(8);
      getFrontAndBackCourses();
    }
  }, [toggleDraws]);

  const handleSendEmail = () => {
    setSendingDraws(true);

    dispatch(
      sendDraws(
        TournamentID,
        (success) => {
          setSendDrawsError("");
          setSendingDraws(false);
          setDrawsSentTextShow(true);
          setTimeout(() => {
            setDrawsSentTextShow(false);
            setEmailConfModalOpen(false);
          }, 1000);
        },
        (err) => {
          setSendDrawsError(err.message);
          setSendingDraws(false);
          setEmailConfModalOpen(false);
        }
      )
    );
  };

  //#endregion

  return (
    <>
      <Grid container p={2}>
        <Grid item container={12}>
          <Grid item container p={2} xs={12} spacing={2}>
            <Grid item container xs={10}>
              <Grid item container xs={12}>
                <Grid item xs={3}>
                  <HeaderItemComponent text="Tournament" rightBorder head />
                </Grid>
                <Grid item xs={3}>
                  <HeaderItemComponent text="Course" rightBorder head />
                </Grid>
                <Grid item xs={3}>
                  <HeaderItemComponent text="Sponsor" rightBorder head />
                </Grid>
                <Grid item xs={3}>
                  <HeaderItemComponent text="Company" head />
                </Grid>
              </Grid>
              <Grid item container xs={12}>
                <Grid item xs={3}>
                  <HeaderItemComponent text={tournamentName} noBG child />
                </Grid>
                <Grid item xs={3}>
                  <HeaderItemComponent text={courseName} noBG child />
                </Grid>
                <Grid item xs={3}>
                  <HeaderItemComponent text={sponsorName} noBG child />
                </Grid>
                <Grid item xs={3}>
                  <HeaderItemComponent text={sponsorCompany} noBG child />
                </Grid>
              </Grid>
            </Grid>
            <Grid item container xs={2} rowSpacing={1}>
              <Grid item xs={12}>
                {showLeaderboard == false &&
                showGroupingBtn == false &&
                groupBtnDraw == false ? (
                  <GroupingButton
                    className={classes.leaderboardBtn}
                    onClick={_handleOnClickLeaderboard}
                    color="primary"
                    fullWidth
                  >
                    Leaderboard
                  </GroupingButton>
                ) : (
                  <GroupingButton
                    className={classes.leaderboardBtn}
                    color="primary"
                    fullWidth
                    onClick={
                      toggleDraws == true
                        ? _handleOnClickGroupingInDraws
                        : _handleOnClickGrouping
                    }
                  >
                    Groupings
                  </GroupingButton>
                )}
              </Grid>
              <Grid item xs={12}>
                {!showCreateDraws && (
                  <span className={classes.createDrawsBtnContainer}>
                    <IconButton
                      aria-label="delete"
                      className={classes.createDrawsBtnIcon}
                      size="small"
                      onClick={_handleCreateDrawsOnClick}
                    >
                      <AddIcon
                        fontSize="small"
                        sx={{
                          backgroundColor: "#06623B",
                          color: "#fff",
                          width: "20px",
                          height: "20px",
                          padding: "2px",
                          borderRadius: "50%",
                        }}
                      />
                    </IconButton>
                    <Typography
                      textAlign="center"
                      className={classes.createDrawsText}
                      pt={0.5}
                    >
                      Create Draws
                    </Typography>
                  </span>
                )}

                {showLeaderboard == false && showRedoDraws && (
                  <span className={classes.createDrawsBtnContainer}>
                    <IconButton
                      aria-label="delete"
                      className={classes.createDrawsBtnIcon}
                      size="small"
                      onClick={_handleRedoDrawsOnClick}
                    >
                      <AddIcon
                        fontSize="small"
                        sx={{
                          backgroundColor: "#06623B",
                          color: "#fff",
                          width: "20px",
                          height: "20px",
                          padding: "2px",
                          borderRadius: "50%",
                        }}
                      />
                    </IconButton>
                    <Typography
                      textAlign="center"
                      className={classes.createDrawsText}
                      pt={0.5}
                    >
                      Redo Draws
                    </Typography>
                  </span>
                )}
              </Grid>
            </Grid>
          </Grid>
          {showLeaderboard == true ? (
            <POTYTournamentDetails />
          ) : (
            <Grid
              item
              container
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
              mt={3}
              xs={12}
            >
              {/* drag drop context here */}
              <DragDropContext
                onDragEnd={handleListItemOnDragEnd}
                onDragStart={_handleDragStart}
              >
                {toggleDraws && (
                  <Grid
                    item
                    xs={9}
                    // spacing={3}
                    p={4}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Card
                      sx={{
                        width: "640px",
                        height: "400px",
                        backgroundColor: "#F2F2F2",
                        border: "1px solid #000000",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CardContent
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Stack spacing={2}>
                          <Typography variant="h6" mb={2} textAlign="center">
                            Create Draws
                          </Typography>

                          <Stack
                            justifyContent="center"
                            direction="row"
                            spacing={2}
                          >
                            <Grid item xs={6}>
                              <Typography>First Tee Off time</Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <OutlinedInput
                                inputRef={timeInputIconRef}
                                notched={false}
                                value={drawTeeTime}
                                className={`${classes.outlineInputBorder} ${classes.timeInput} ${classes.outlinedInputBox}`}
                                startAdornment={
                                  <InputAdornment
                                    className={classes.clockInputAdornment}
                                    position="start"
                                  >
                                    <TextField
                                      className={classes.timeTextField}
                                      type="time"
                                      onChange={_handleOnChangeTeeOff}
                                    />
                                  </InputAdornment>
                                }
                                label="."
                              />
                            </Grid>
                          </Stack>
                          <Stack
                            justifyContent="center"
                            direction="row"
                            spacing={2}
                          >
                            <Grid item xs={6}>
                              <Typography>Time between flights</Typography>
                            </Grid>
                            <Grid
                              item
                              xs={6}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <TextField
                                variant="outlined"
                                size="small"
                                label=""
                                sx={{
                                  width: "100%",
                                  backgroundColor: "#fff",
                                  "& legend": { display: "none" },
                                  "& fieldset": { top: 0 },
                                }}
                                type="number"
                                value={count}
                                onChange={(e) => setCount(e.target.value)}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Box>
                                        <Divider
                                          orientation="vertical"
                                          sx={{
                                            height: "13px !important",
                                            margin: "5px",
                                            backgroundColor: "black",
                                          }}
                                        />
                                      </Box>
                                      <Box className={classes.inputArrow}>
                                        <img
                                          src={arrowUp}
                                          alt=""
                                          width="15px"
                                          onClick={onIncrement}
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        />
                                      </Box>

                                      <Box>
                                        <Divider
                                          orientation="vertical"
                                          sx={{
                                            height: "13px !important",
                                            margin: "5px",
                                            backgroundColor: "black",
                                          }}
                                        />
                                      </Box>
                                      <Box className={classes.inputArrow}>
                                        <img
                                          src={arrowDown}
                                          alt=""
                                          width="15px"
                                          onClick={onDecrement}
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        />
                                      </Box>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                              <Typography
                                sx={{
                                  ml: 1,
                                }}
                              >
                                (Minutes)
                              </Typography>
                            </Grid>
                          </Stack>
                          <Stack
                            justifyContent="center"
                            direction="row"
                            spacing={2}
                          >
                            <Grid item xs={6}>
                              <Typography>Tee-Offs from</Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Select
                                variant="outlined"
                                value={teeOffsFrom}
                                onChange={_handleChangeTeeOff}
                                className={classes.outlineInputBorder}
                                defaultValue="Both Sides"
                                fullWidth
                                label="."
                                sx={{
                                  backgroundColor: "#FFF",
                                }}
                              >
                                {teeOffsFromSelectData.map((item, index) => {
                                  return (
                                    <MenuItem value={item}>
                                      <Grid container item>
                                        <Grid item xs={10}>
                                          {item}
                                        </Grid>
                                      </Grid>
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </Grid>
                          </Stack>
                          <Stack
                            justifyContent="center"
                            direction="row"
                            spacing={2}
                          >
                            <Grid item xs={6}>
                              {" "}
                              <Typography>Draw Method</Typography>
                            </Grid>
                            <Grid item xs={6}>
                              {" "}
                              <Select
                                variant="outlined"
                                value={drawVal}
                                onChange={_handleChangeDrawMethod}
                                className={classes.outlineInputBorder}
                                fullWidth
                                label="."
                                sx={{
                                  backgroundColor: "#FFF",
                                }}
                              >
                                {drawCreationModes.map((item, index) => {
                                  return (
                                    <MenuItem value={item}>
                                      <Grid container item>
                                        <Grid item xs={10}>
                                          {item}
                                        </Grid>
                                      </Grid>
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </Grid>
                          </Stack>
                          <Grid container>
                            <Grid item xs={12}>
                              <Grid
                                item
                                container
                                sx={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <Grid item xs={3}>
                                  <Button
                                    className={classes.confirmDrawBtn}
                                    onClick={handleDraws}
                                  >
                                    Confirm
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Stack>
                      </CardContent>
                    </Card>
                  </Grid>
                )}

                {/* ----------------------- Group boxes area ----------------------- */}

                {showCreateDraws === false && groups.length === 0 && (
                  <Grid item xs={9}>
                    <Typography
                      variant="h5"
                      gutterBottom
                      sx={{
                        textAlign: "center",
                        marginTop: "40px",
                        fontSize: "20px",
                      }}
                    >
                      Create Draws to proceed
                    </Typography>
                  </Grid>
                )}

                {showRedoDraws && (
                  <Grid item xs={9} px={1}>
                    <Grid
                      container
                      xs={12}
                      className={classes.scrollBarStyle}
                      sx={{ maxHeight: "75vh", overflowY: "auto" }}
                    >
                      {groups?.map((group, index) => {
                        return (
                          <Grid
                            item
                            spacing={1}
                            xs={12}
                            md={5.5}
                            xl={4}
                            sx={{ height: "fit-content" }}
                          >
                            <Card
                              sx={{
                                width: "92%",
                                mb: 1,
                                border: "1px solid #06623B",
                              }}
                            >
                              <CardContent sx={{ padding: 1 }}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    mb: 1,
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      textTransform: "capitalize",
                                      fontWeight: "700",
                                      ml: 1,
                                    }}
                                  >
                                    {group.group_name}
                                  </Typography>
                                  <IconButton
                                    aria-label="remove group"
                                    color="error"
                                    onClick={() =>
                                      _handleRemoveGroupOnClick(index)
                                    }
                                  >
                                    <RemoveCircleRoundedIcon />
                                  </IconButton>
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    mb: 1,
                                    mx: 1,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: 14,
                                      fontWeight: "700",
                                      color: "#FF0000",
                                    }}
                                  >
                                    {group.time}
                                  </Typography>
                                  <Select
                                    variant="outlined"
                                    disabled={false}
                                    value={group.course_name}
                                    onChange={(e) =>
                                      _handleChangeCourse(e, index)
                                    }
                                    className={classes.outlineInputBorder}
                                    label="."
                                    sx={{ flex: 1, ml: 1 }}
                                  >
                                    <MenuItem
                                      selected
                                      key="Select Course"
                                      value="Select Course"
                                    >
                                      Select Course
                                    </MenuItem>

                                    <MenuItem
                                      key={teeAndHandicap?.front_9}
                                      value={teeAndHandicap?.front_9}
                                    >
                                      <Grid container item>
                                        <Grid item xs={10}>
                                          {teeAndHandicap?.front_9}
                                        </Grid>
                                      </Grid>
                                    </MenuItem>
                                    <MenuItem
                                      key={teeAndHandicap?.back_9}
                                      value={teeAndHandicap?.back_9}
                                    >
                                      <Grid container item>
                                        <Grid item xs={10}>
                                          {teeAndHandicap?.back_9}
                                        </Grid>
                                      </Grid>
                                    </MenuItem>
                                  </Select>
                                </Box>
                                <Droppable droppableId={group.group_name}>
                                  {(provided) => (
                                    <div
                                      ref={provided.innerRef}
                                      key={uniqid()}
                                      className={clsx(
                                        classes.group_droppableArea,
                                        {
                                          [classes.group_droppableAreaActive]:
                                            groupDragStarted,
                                        }
                                      )}
                                      {...provided.droppableProps}
                                    >
                                      {group?.draw_players?.length > 0 && (
                                        <List
                                          sx={{
                                            mx: 1,
                                          }}
                                          component="section"
                                          ref={provided.innerRef}
                                          {...provided.droppableProps}
                                        >
                                          {group.draw_players?.map(
                                            (draw_player, index) => (
                                              <Draggable
                                                key={draw_player.user_id}
                                                draggableId={draw_player.name}
                                                index={index}
                                              >
                                                {(provided) => (
                                                  <Box>
                                                    <Grid
                                                      container
                                                      alignItems="center !important"
                                                      sx={{ mb: 1 }}
                                                      {...provided.draggableProps}
                                                      {...provided.dragHandleProps}
                                                      ref={provided.innerRef}
                                                    >
                                                      <Grid
                                                        item
                                                        xs={4}
                                                        lg={4.6}
                                                      >
                                                        <Typography
                                                          className={
                                                            classes.playerListText
                                                          }
                                                        >
                                                          {filterPlayerName(
                                                            draw_player?.user_id
                                                          )}
                                                        </Typography>
                                                      </Grid>
                                                      <Grid
                                                        item
                                                        xs={7}
                                                        lg={7}
                                                        sx={{ ml: "auto" }}
                                                      >
                                                        <Box
                                                          sx={{
                                                            display: "flex",
                                                            width: "100%",
                                                            height: "41px",
                                                            border:
                                                              "1px solid #c4c4c4",
                                                            overflow: "hidden",
                                                            borderRadius: "5px",
                                                          }}
                                                        >
                                                          <Typography
                                                            className={
                                                              classes.groupTypo
                                                            }
                                                          >
                                                            {
                                                              draw_player.playing_handicap
                                                            }
                                                          </Typography>

                                                          <Select
                                                            variant="outlined"
                                                            value={
                                                              draw_player.tee
                                                            }
                                                            defaultValue={
                                                              draw_player.tee
                                                            }
                                                            displayEmpty={true}
                                                            onChange={(e) =>
                                                              _handleChangeTeeColor(
                                                                e,
                                                                group.group_name,
                                                                draw_player.user_id
                                                              )
                                                            }
                                                            // disabled={
                                                            //   draw_player
                                                            //     ?.mp_score
                                                            //     .length > 0
                                                            //     ? true
                                                            //     : false
                                                            // }
                                                            fullWidth
                                                            className={`${classes.outlineInputBorder} ${classes.groupSelect}`}
                                                            sx={{
                                                              color: "#FFF",
                                                              "& .MuiSelect-select":
                                                                {
                                                                  height:
                                                                    "100%",
                                                                  textAlign:
                                                                    "center",
                                                                  paddingTop:
                                                                    "25px",
                                                                  backgroundColor:
                                                                    draw_player.tee ===
                                                                    "blue"
                                                                      ? "#0000FF"
                                                                      : draw_player.tee ===
                                                                        "yellow"
                                                                      ? "#FFC300"
                                                                      : draw_player.tee ===
                                                                        "white"
                                                                      ? "#C4C4C4"
                                                                      : draw_player.tee ===
                                                                        "black"
                                                                      ? "#000000"
                                                                      : "transparent",
                                                                },
                                                            }}
                                                          >
                                                            {[
                                                              "blue",
                                                              "white",
                                                              "yellow",
                                                              "black",
                                                            ].map(
                                                              (
                                                                Teeitem,
                                                                index
                                                              ) => {
                                                                return (
                                                                  <MenuItem
                                                                    key={index}
                                                                    value={
                                                                      Teeitem
                                                                    }
                                                                  >
                                                                    <Grid
                                                                      container
                                                                      item
                                                                    >
                                                                      <Grid
                                                                        item
                                                                        xs={12}
                                                                      >
                                                                        {
                                                                          Teeitem
                                                                        }
                                                                      </Grid>
                                                                    </Grid>
                                                                  </MenuItem>
                                                                );
                                                              }
                                                            )}
                                                          </Select>
                                                        </Box>
                                                      </Grid>
                                                    </Grid>
                                                  </Box>
                                                )}
                                              </Draggable>
                                            )
                                          )}
                                        </List>
                                      )}
                                      {provided.placeholder}
                                    </div>
                                  )}
                                </Droppable>
                              </CardContent>
                            </Card>
                          </Grid>
                        );
                      })}
                      <Grid
                        item
                        spacing={1}
                        xs={12}
                        md={5.5}
                        xl={4}
                        sx={{ height: "fit-content" }}
                        onClick={(e) => _handleAddGroup(e, index)}
                      >
                        <Box
                          sx={{
                            border: "1px dashed green",
                            width: "92%",
                            borderRadius: "10px",
                          }}
                        >
                          <CardContent
                            sx={{
                              minHeight: "325px",
                              padding: "7px",
                              display: "flex !important",
                              alignItems: "center !important",
                              justifyContent: "center !important",
                              flexDirection: "column",
                            }}
                          >
                            <AddIcon
                              sx={{
                                color: "#06623B",
                                fontSize: "50px",
                              }}
                            />
                            <Typography
                              variant="h6"
                              fontWeight="700"
                              sx={{
                                color: "#06623B",
                              }}
                            >
                              Add Group
                            </Typography>
                          </CardContent>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                {/* --------------- Player List Box --------------- */}
                <Grid
                  item
                  xs={3}
                  className={classes.scrollBarStyle}
                  sx={{ maxHeight: "65vh", overflowY: "auto" }}
                >
                  <Stack className={classes.stack2} p={1} mr={1}>
                    <Box component="span" className={classes.groupingBox}>
                      <Typography textAlign="center" color="white">
                        Player List
                      </Typography>
                    </Box>
                  </Stack>
                  <Stack>
                    <Droppable droppableId="confirmed">
                      {(provided) => (
                        <List
                          sx={{ width: "100%", marginTop: 1 }}
                          component="nav"
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          <ListItemButton
                            onClick={() => handleListCollapseClick("confirmed")}
                          >
                            <ListItemText
                              primary={`Confirmed (${playerList["confirmed"].length})`}
                              className={classes.playerListHeading}
                            />
                            {openedList["confirmed"] ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </ListItemButton>
                          <Collapse
                            in={openedList["confirmed"]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <List
                              component="div"
                              disablePadding
                              className={clsx(classes.listDroppableArea, {
                                [classes.listDroppableAreaActive]:
                                  groupDragStarted,
                              })}
                            >
                              {playerList["confirmed"].map((item, index) => (
                                <>
                                  <Draggable
                                    key={item?.name}
                                    draggableId={item.name + ""}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <ListItemText
                                        sx={{
                                          pl: 4,
                                        }}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        {item?.name}
                                      </ListItemText>
                                    )}
                                  </Draggable>
                                  <Box
                                    sx={{
                                      borderBottom: "1px solid #C4C4C4",
                                    }}
                                  ></Box>
                                </>
                              ))}
                              {provided.placeholder}
                            </List>
                          </Collapse>
                        </List>
                      )}
                    </Droppable>

                    <Droppable droppableId="pending">
                      {(provided) => (
                        <List
                          sx={{
                            width: "100%",
                            marginTop: 1,
                            marginBottom: 1,
                          }}
                          component="nav"
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          <ListItemButton
                            onClick={() => handleListCollapseClick("pending")}
                          >
                            <ListItemText
                              primary={`Pending (${playerList["pending"].length})`}
                              className={classes.playerListHeading}
                            />
                            {openedList["pending"] ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </ListItemButton>
                          <Collapse
                            in={openedList["pending"]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <List
                              component="div"
                              disablePadding
                              className={clsx(classes.listDroppableArea, {
                                [classes.listDroppableAreaActive]:
                                  groupDragStarted,
                              })}
                            >
                              {playerList["pending"].map((item, index) => (
                                <>
                                  <Draggable
                                    key={item?.name}
                                    draggableId={item.name + ""}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <ListItemText
                                        sx={{
                                          pl: 4,
                                        }}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        {item?.name}
                                      </ListItemText>
                                    )}
                                  </Draggable>
                                  <Box
                                    sx={{
                                      borderBottom: "1px solid #C4C4C4",
                                    }}
                                  ></Box>
                                </>
                              ))}
                              {provided.placeholder}
                            </List>
                          </Collapse>
                        </List>
                      )}
                    </Droppable>

                    <Droppable droppableId="refused">
                      {(provided) => (
                        <List
                          sx={{
                            width: "100%",
                            minHeight: 250,
                          }}
                          component="nav"
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          <ListItemButton
                            onClick={() => handleListCollapseClick("refused")}
                          >
                            <ListItemText
                              primary={`Refused (${playerList["refused"].length})`}
                              className={classes.playerListHeading}
                            />
                            {openedList["refused"] ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </ListItemButton>
                          <Collapse
                            in={openedList["refused"]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <List
                              component="div"
                              disablePadding
                              className={clsx(classes.listDroppableArea, {
                                [classes.listDroppableAreaActive]:
                                  groupDragStarted,
                              })}
                            >
                              {playerList["refused"].map((item, index) => (
                                <>
                                  <Draggable
                                    key={item?.name}
                                    draggableId={item.name + ""}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <ListItemText
                                        sx={{
                                          pl: 4,
                                        }}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        {item?.name}
                                      </ListItemText>
                                    )}
                                  </Draggable>
                                  <Box
                                    sx={{
                                      borderBottom: "1px solid #C4C4C4",
                                    }}
                                  ></Box>
                                </>
                              ))}
                              {provided.placeholder}
                            </List>
                          </Collapse>
                        </List>
                      )}
                    </Droppable>
                  </Stack>
                </Grid>
              </DragDropContext>
            </Grid>
          )}

          <Grid item container my={2}>
            <Grid item xs={12}>
              <Divider />
            </Grid>
          </Grid>

          <Box sx={{ width: "100%" }} display="flex" justifyContent="flex-end">
            {showLeaderboard == false && (
              <>
                <LoadingButton
                  loading={formSaving}
                  // loadingIndicator="Saving Draws"
                  onClick={() => _handleOnSave()}
                  className={classes.SaveBtn}
                  variant="outlined"
                  sx={{
                    width: 180,
                    height: 40,
                    mr: 1,
                    backgroundColor: formSavedTextShow ? "#FFF" : "#2C633C",
                    color: formSavedTextShow ? "#2C633C" : "#FFF",
                    ":hover": { backgroundColor: "#2C633C" },
                  }}
                >
                  {formSavedTextShow ? "Saved!" : "Save"}
                </LoadingButton>

                <LoadingButton
                  loading={sendingDraws}
                  // loadingIndicator="Saving Draws"
                  onClick={() => _handleSendDraws()}
                  disabled={sendDrawsError !== "" ? true : false}
                  className={classes.SendDrawsBtn}
                  variant="outlined"
                  sx={{
                    minWidth: 180,
                    height: 40,
                    backgroundColor: drawsSentTextShow ? "#2C633C" : "#E80303",
                    color: "#fff !important",
                    whiteSpace: "nowrap !important",
                    borderRadius: "10px",
                  }}
                >
                  <span>
                    {sendDrawsError !== ""
                      ? sendDrawsError
                      : drawsSentTextShow
                      ? "Draws Sent!"
                      : "Send Draws"}
                  </span>
                </LoadingButton>
              </>
            )}
          </Box>
        </Grid>
      </Grid>

      <MainModal
        show={emailConfModalOpen}
        closeModal={() => setEmailConfModalOpen(false)}
        modalHeadTitle="Email Confirmation"
        variant="contained"
        width="500px"
        showBtn
        btnLeftTitle="Cancel"
        btnRightTitle={`${sendingDraws ? "Sending" : "Send"}`}
        cb={() => setEmailConfModalOpen(false)}
        btnCloseModal={() => handleSendEmail(false)}
        btnLeftsx={{
          backgroundColor: "red",
          color: "#fff",
          minWidth: "120px",
          ":hover": {
            background: "red",
          },
        }}
        btnRightsx={{
          backgroundColor: "green",
          color: "#fff",
          minWidth: "120px",
          ":hover": {
            background: "green",
          },
        }}
      >
        <Box sx={{ margin: "15px 0px" }}>
          <Typography>
            Pressing the Send button will send Email to all the selected
            participants.
          </Typography>

          <Typography sx={{ fontWeight: 700, mt: 2 }}>
            Are you sure you want to send?
          </Typography>
        </Box>
      </MainModal>
    </>
  );
}

const index = () => {
  return (
    <>
      <MainMenu>
        <Grid container>
          <Grid item xs={12}>
            <Paper elevation={3}>
              <TournamentDetails />
            </Paper>
          </Grid>
        </Grid>
      </MainMenu>
    </>
  );
};

export default index;
